import axios from 'axios'

export default {
    namespaced: true,

    state: {
        authenticated: sessionStorage.getItem('authenticated') || false,
        admin: false,
        user: sessionStorage.getItem('user') || {student_id: null, name: null, initials: null},        
        userRecord: null,
        studentRecord: null,
        overlay: false,
        dialog: false,
        loginErrors: '',
        resetPassword: false,
        newPassword: '',
        displayPasswordChanged: false,
        validStudentID: false,
        step: 1,        
        passwordHint: 'yyyymmdd',
        passwordPlaceholder: ' ',
        schoolName: process.env.VUE_APP_THEME_SCHOOL,          
    },

    getters: {
        getAuthenticated (state) {
            return state.authenticated
        },

        getUser (state) {
            return state.user
        },      

        getUserRecord(state){
            return state.userRecord
        },

        getOverlay(state){
            return state.overlay
        },

        getStudentRecord(state){
            return state.studentRecord
        },

        getDialog(state){
            return state.dialog
        },

        getLoginErrors(state){
            return state.loginErrors
        },

        getResetPassword(state){
            return state.resetPassword
        },

        getNewPassword(state){
            return state.newPassword
        },

        getDisplayPasswordChanged(state){
            return state.displayPasswordChanged
        },

        getStudentIDValidation(state){
            return state.validStudentID
        },

        getStep(state){
            return state.step
        },
        
        getPasswordHint(state){
            return state.passwordHint
        },

        getPasswordPlaceholder(state){
            return state.passwordPlaceholder
        },           

        getAdmin(state){
            return state.admin
        },

        getSchoolName (state) {
            return state.schoolName
        },
    },

    mutations: {
        setAuthenticated (state, value) {
            state.authenticated = value
        },

        setUser (state, value) {
            state.user = value
        },

        setUserRecord (state, value){
            state.userRecord = value
        },

        setOverlay (state, value){
            state.overlay = value
        },

        setStudentRecord(state, value){
            state.studentRecord = value
        },

        setDialog(state, value){
            state.dialog = value
        },

        setLoginErrors(state, value){
            state.loginErrors = value
        },

        setResetPassword(state, value){
            state.resetPassword = value
        },

        setNewPassword(state, value){
            state.newPassword = value
        },

        setDisplayPasswordChanged(state, value){
            state.displayPasswordChanged = value
        },

        setStudentIDValidation(state, value){
            state.validStudentID = value
        },

        setStep(state, value){
            state.step = value
        },

        setPasswordHint(state, value){
            state.passwordHint = value
        },

        setPasswordPlaceholder(state, value){
            state.passwordPlaceholder = value
        },

        setAdmin(state, value){
            state.admin = value
        }
    },

    actions: {

        async signIn ({ commit, dispatch, getters }, credentials){            
            commit('setOverlay', true);           
            try {
                await axios.get('/sanctum/csrf-cookie')
                const { data } = await axios.post('/api/login-student', credentials);
                sessionStorage.setItem('authenticated', true);
                sessionStorage.setItem('user', JSON.stringify(data));
                commit('setUser', { student_id: data.student_id, password: getters.getUser.password})
                commit('setAuthenticated', true);
                commit('setLoginErrors', '');
                if(data.name == 'Admin'){
                    commit('setAdmin', true);
                    console.log('admin sign in');
                }                   
                await dispatch('student');  
                
            } catch (error) {
                console.log(error.response);                
                commit('setLoginErrors', error.response.data.message);
                commit('setAuthenticated', false);
                commit('setOverlay', false);  
            } 
        },

        async adminSignIn({ commit, dispatch }, credentials){
            commit('setOverlay', true);
            await axios.get('/sanctum/csrf-cookie')
            await axios.post('/api/admin-login', credentials)
                .then(res => {
                    console.log(res.status);
                    commit('setLoginErrors', '')
                    commit('setAuthenticated', true);
                    commit('setUser', credentials);
                    commit('setOverlay', false);
                })
                .catch(error => {
                    dispatch('serverError', error)
                })           
        },

        async student({ commit, getters}){  
            let url = '/api/student-record/' + getters.getUser.student_id;
            //console.log(`url: ${url}`);
            return axios.get(url)
                .then(response => {                                        
                    commit('setStudentRecord', response.data[0]);
                    let userInitials = response.data[0].first_name.trim().charAt(0)+response.data[0].last_name.charAt(0);
                    let userName = response.data[0].first_name+' '+response.data[0].last_name;
                    const user = {
                        student_id: response.data[0].id,
                        name: userName,
                        initials: userInitials
                    }
                    commit('setUser', JSON.stringify(user));
                    sessionStorage.setItem('user', JSON.stringify(user));
                    commit('setOverlay', false);
                    //console.log(`Action user Authenticated: ${getters.getAuthenticated}`)
                })
                .catch(error => {                    
                    commit('setUser', null)
                    console.log(error)
                })
                
        },

        async getUser({ getters, commit }){
            commit('setOverlay', true);
            console.log("getting user information...");
            let url = '/api/user/' + getters.getUser.student_id;
            try{
                const { data } = await axios.get(url);
                //console.log(response);
                commit('setOverlay', false);
                if(data.length != 0){
                    commit('setStudentIDValidation', true)
                    commit('setLoginErrors', '');
                    commit('setUserRecord', data[0]);
                    commit('setStep', 2);
                    if(data[0].password_reset == 1){
                        commit('setResetPassword', true);
                        commit('setPasswordHint', 'yyyymmdd');
                        commit('setPasswordPlaceholder', 'Enter date of birth');                        
                    }
                    else{
                        commit('setResetPassword', false);
                        commit('setPasswordHint', '');
                        commit('setPasswordPlaceholder', 'Enter password')                         
                    } 
                }
                else{
                    commit('setLoginErrors', 'Student ID not found');
                    commit('setStudentIDValidation', false)
                    commit('setAuthenticated', false);                                      
                }    
            } catch (error) {
                commit('setLoginErrors', error);
            }            
        },

        async changePassword({ getters }){
            console.log(`Password: ${getters.getNewPassword}`);
            console.log(`Student Id: ${getters.getUser.student_id}`);
            let url = '/api/change-password-student';
            return await axios.post(url, {
                "student_id" : getters.getUser.student_id,
                "password" : getters.getNewPassword,
            })
            
        },        

        async signOut({commit}){                       
            await axios.post('/logout')
                    .then(response => {
                        console.log(response);
                    })
            return commit('setAuthenticated', false); 
        },
        
        async saveRecord({getters}){
            //console.log(getters.getStudentRecord);
            let studentRecord = getters.getStudentRecord;            
            return axios.post('/api/student', studentRecord);
        },

       checkSession({dispatch}){           
           console.log(`Cookie Set: ${dispatch('cookieSet', 'ans_api_session')}`);
       },

       async getStudents(){
           return await axios.get('/api/students')
       },

       async resetPassword({ commit, getters }, resetPassword){
            commit('setOverlay', true);
            await axios.post('/api/change-password-student',{
                "student_id" : getters.getUser.id,
                "reset_password" : resetPassword,
            });
            commit('setResetPassword', resetPassword);
            commit('setDisplayPasswordChanged', true);
            commit('setOverlay', false);
       },

       cookieSet(cookieName){
           let name = cookieName + "=";
           let decodedCookie = decodeURIComponent(document.cookie);
           let cookies = decodedCookie.split(';');
           for(var i = 0; i < cookies.length; i++){
               var c = cookies[i];
               while(c.charAt(0) == ' '){
                   c = c.substring(1);
               }
               if(c.indexOf(name) == 0){
                    return true;
               }
           }
           return false;
       },

       serverError({ commit }, err ){
            console.log(err.response)
            var hasErrors = Object.prototype.hasOwnProperty.call(err.response, 'errors');                                     
            if( hasErrors && err.response.data.errors.message.length != 0){
                commit('setLoginErrors', err.response.data.errors.message[0]);
            }
            else{
                commit('setLoginErrors', err.response.statusText);
            }                    
            commit('setAuthenticated', false);
            commit('setOverlay', false);
       }
    }
}